export default {
  //common
  passwordLabel: "पासवर्ड",
  confirmPassword: "पासवर्डची पुष्टी करा",
  login_Button: "लॉगिन",
  login_id_required: "लॉगिन आयडी आवश्यक आहे",
  password_required: "पासवर्ड आवश्यक आहे",
  forgot_Password: "पासवर्ड विसरलात?",
  forgot_PasswordPage: "पासवर्ड विसरलात",
  descLogin: "‘लॉगिन’ क्लिक करून, आपण खालील गोष्टींचा आढावा घेतल्याचे मान्य करता",
  agreeLogin: "आणि आमच्या",
  termsConditions: "अटी आणि शर्ती",
  privacyLogin: "गोपनीयता धोरण",
  disclaimer: "अस्वीकृती",
  tipsSafeBanking: "सुरक्षित बँकिंगसाठी टिप्स",
  firstTimeUser: "प्रथमच वापरणारा वापरकर्ता",
  registerHere: "येथे नोंदणी करा",
  accountNumberLabel: "खाते क्रमांक",
  selectAccountNumber: "खाते क्रमांक निवडा",
  accountHolderName: "खात्याच्या मालकाचे नाव",
  account_required: "खाते क्रमांक आवश्यक आहे",
  accountType_required: "खात्याचा प्रकार आवश्यक आहे",
  accountHolderName_required: "खातेदाराचे नाव आवश्यक आहे",
  messageNoRecordFound: "माफ करा, जुळणारे रेकॉर्ड आढळले नाहीत",
  accountNumberLabelPlaceholder: "खाते क्रमांक निवडा",

  // Corporate Login
  domainId: "डोमेन आयडी/कंपनी आयडी",
  useridCor: "वापरकर्ता आयडी",
  useridCorRequired: "वापरकर्ता आयडी आवश्यक आहे",
  userIdPlaceholder: "आपला वापरकर्ता आयडी",
  domainIdRequired: "डोमेन आयडी/कंपनी आयडी आवश्यक आहे",
  PasswordCor: "पासवर्ड",
  confirm_PasswordCor: "पासवर्डची पुष्टी करा",
  PasswordCorRequired: "पासवर्ड आवश्यक आहे",
  confirmPasswordCorRequired: "पासवर्डची पुष्टी आवश्यक आहे",
  patternMessage: "पासवर्ड आवश्यक स्वरूपाशी जुळत नाही",
  corForgotMsgHeading: "कृपया डोमेन आयडी/कंपनी आयडी प्रविष्ट करा, आम्ही नोंदणीकृत मोबाइल क्रमांकावर OTP पाठवू",
  sendButton: "पाठवा",

  // Register Login
  card_RegisterHeading: "नोंदणी",
  card_WithCard: "कार्डसह",
  Card_withCustNo: "ग्राहक क्रमांकासह",
  Card_CustomerNo: "ग्राहक क्रमांक",
  Card_CustomerNoRequired: "ग्राहक क्रमांक आवश्यक आहे",
  Card_CardNo: "कार्ड क्रमांक",
  Card_CardNoRequired: "कार्ड क्रमांक आवश्यक आहे",
  Card_CVV: "CVV",
  Card_CVVRequired: "CVV आवश्यक आहे",
  CVV_Format: "कृपया वैध CVV स्वरूप प्रविष्ट करा",
  Card_expiryDate: "समाप्ती तारीख",
  accept_msg: "मी स्वीकारतो",
  card_termscondition: "अटी आणि शर्ती",
  card_registerButton: "नोंदणी करा",
  withCustNo: "कृपया ग्राहक क्रमांक प्रविष्ट करा, आम्ही नोंदणीकृत मोबाइल क्रमांकावर OTP पाठवू",

  // Account Statement
  fromDate: "पासून तारीख",
  toDate: "पर्यंत तारीख",
  buttonSubmit: "सबमिट करा",
  buttonReset: "रीसेट करा",
  buttonCancel: "रद्द करा",
  buttonAccept: "स्वीकारा",
  BalanceLabel: "शिल्लक",
  accountTypeLabel: "खात्याचा प्रकार",
  noDataAvailable: "माहिती उपलब्ध नाही",
  processPDF: "PDF प्रक्रिया करा",
  viewPDF: "PDF पहा",

  statementList: "स्टेटमेंट यादी",
  column_download: "डाउनलोड",
  statement_columnFromDate: "पासून तारीख",
  statement_columnToDate: "पर्यंत तारीख",
  statement_columnFileName: "फाईलचे नाव",
  statement_columnStatus: "स्थिती",
  statement_columnAccNumber: "खाते क्रमांक",
  statement_createdBy: "द्वारे तयार केले",
  statement_createdDate: "तयार केलेली तारीख",
  statementDownloadInfo: "प्रिय ग्राहक, गोपनीयता जपण्यासाठी आपले ई-स्टेटमेंट पासवर्ड संरक्षित आहे.",
  estatementPssword: "ई-स्टेटमेंट पासवर्ड:",
  downloadInfoThirdLine: "आपले खाते ई-स्टेटमेंट पाहण्यासाठी, फक्त ग्राहक क्रमांक पासवर्ड म्हणून प्रविष्ट करा.",
  forEx: "उदाहरणार्थ:",
  downloadInfoCustomer: "- जर तुमचा ग्राहक क्रमांक असेल",
  downloadCustNo: "123456",
  downloadCustNo4digit: "123456",
  downloadInfoLast: "तर तुमचा पासवर्ड असेल",
  downloadExCustNo: "004561",
  downloadExCustNo4digit: "4561",
  downloadConfirmationMessage: "आपण आपले ई-स्टेटमेंट डाउनलोड करू इच्छिता याची खात्री आहे का?",
  NoButtonDownload: "नाही",
  YesButtonDownload: "होय",

  // Header
  Header_IB: "इंटरनेट बँकिंगमध्ये स्वागत आहे",
  Header_CB: "कॉर्पोरेट बँकिंगमध्ये स्वागत आहे",
  Header_lastlogin: "शेवटचा लॉगिन",

  login_enterdetailsheading: "कृपया आपले तपशील प्रविष्ट करा.",
  login_LoginIdLabel: "लॉगिन आयडी",
  login_validationLoginId: "आयडीमध्ये 4 मोठ्या अक्षरांनंतर 8 अंक असले पाहिजेत",
  login_forgotPassword: "पासवर्ड विसरलात",
  login_termsText: "‘लॉगिन’ क्लिक करून, आपण खालील गोष्टींचा आढावा घेतल्याचे मान्य करता",
  login_agreetext: "आणि आमच्या",
  login_termsCondition: "अटी आणि शर्ती",
  login_privacypolicy: "गोपनीयता धोरण",
  login_disclaimer: "अस्वीकृती",
  login_tipsforsafe: "सुरक्षित बँकिंगसाठी टिप्स",
  login_copyright: "कॉपीराईट 2025 | सर्व हक्क राखीव",
  login_footerDeveloped: "डेव्हलप केलेले",
  login_footerSaraswat: "सारस्वत इन्फोटेक प्रायव्हेट लिमिटेड",

  // Forget Password - Internet Banking
  forgetpassword: "पासवर्ड विसरलात",
  forgetpassword_message: "कृपया ग्राहक क्रमांक प्रविष्ट करा, आम्ही नोंदणीकृत मोबाइल क्रमांकावर OTP पाठवू",
  forgetpassword_Loginid: "लॉगिन आयडी",
  forgetpassword_send: "पाठवा",

  resetPassword: "पासवर्ड रीसेट करा",

  // OTP - Internet Banking
  otp_loginHeading: "इंटरनेट बँकिंगसाठी लॉगिन करा",
  otp_enterHeading: "चार अंकी OTP प्रविष्ट करा",
  otp_messageError: "आपल्याकडे",
  otp_messageErrorleftMessage: "प्रयत्न बाकी आहेत",

  // Home.js
  home_HeadingAccountDetails: "खाते तपशील",
  home_HeadingAccountStatement: "खाते विवरण",
  home_HeadingStatement: "सारांश",
  home_financial: "आर्थिक विहंगावलोकन",
  miniStatementSummary: "मिनी स्टेटमेंट",
  laonSummary: "कर्जे",
  loanStmtHeading: "कर्ज स्टेटमेंट",
  sumMiniStmtColumntransDate: "व्यवहार दिनांक",
  sumMiniStmtColumnParticulars: "तपशील",
  sumMiniStmtColumnStatus: "स्थिती",
  sumMiniStmtColumnAmount: "रक्कम",

  // Account.js
  AccountStatementsHeading: "खाते स्टेटमेंट",
  PerSetCustLimit: "ग्राहक मर्यादा सेट करा",

  // Account Main Heading
  accountSummary_Heading: "खाते शिल्लक सारांश",
  accountTable_Heading: "खातेदाराचे नाव",
  account_Statement: "खाते स्टेटमेंट",
  account_customerLimit: "ग्राहक मर्यादा सेट करा",
  accountTable_accountName: "खाते क्रमांक",
  accountTable_accountType: "खात्याचा प्रकार",
  accountTable_Balance: "शिल्लक",
  accountTable_Details: "तपशील",
  accountTable_Branchcode: "शाखा कोड",
  account_miniStatement: "मिनी स्टेटमेंट",
  account_Loan: "कर्ज",
  ministatement_account: "खाते निवडा",
  statement_Heading: "व्यवहार स्टेटमेंट",
  transaction_Date: "व्यवहार दिनांक",

  // Customer Limit
  accountSetCust_Heading: "ग्राहक मर्यादा सेट करा",
  customerNoSetLimit: "ग्राहक क्रमांक",
  selectCustomerNoSetLimit: "ग्राहक क्रमांक निवडा",
  custNoIsrequired: "ग्राहक क्रमांक आवश्यक आहे",
  neftCustLimit: "NEFT",
  rtgsCustLimit: "RTGS",
  internalCustLimit: "आंतरगत",
  perDayTranxLimit: "दररोज व्यवहार मर्यादा",
  currentLimit: "सद्य मर्यादा",
  perDayMaxTranxLimit: "दररोज व्यवहाराची कमाल रक्कम:",

  // Account Statement
  noRowsDisplayMessage: "ओळी नाहीत",
  recentTransaction: "अलीकडील व्यवहार",
  accStmtSelectAcc: "खाते निवडा",
  transStatementHeading: "व्यवहार विवरण",
  accStmtColumntransDate: "व्यवहार दिनांक",
  accStmtColumnParticulars: "तपशील",
  accStmtColumnStatus: "स्थिती",
  accStmtColumnAmount: "रक्कम",

  // Beneficiary
  column_nickname: "टोपणनाव",
  column_name: "नाव",
  column_acconno: "खाते क्रमांक",
  column_Ifsc: "IFSC",
  column_createdDatenadTime: "तयार केलेली तारीख आणि वेळ",
  column_delete: "हटवा",
  add_Benficiary: "लाभार्थी जोडा",

  // Beneficiary Master
  BeneAccountNumber: "खाते क्रमांक",
  BeneAccountNumberReq: "खाते क्रमांक आवश्यक आहे",
  BeneIFSCCode: "IFSC कोड",
  BeneIFSCCodeReq: "IFSC कोड आवश्यक आहे",
  validIFSCCode: "कृपया वैध IFSC कोड प्रविष्ट करा",
  BeneNickname: "टोपणनाव",
  BeneNicknameReq: "टोपणनाव आवश्यक आहे",
  BeneFullName: "पूर्ण नाव",
  BeneFullNameReq: "पूर्ण नाव आवश्यक आहे",
  BeneMobileNumber: "मोबाइल क्रमांक",
  buttonReset: "रीसेट करा",
  buttonAddBeneficiary: "लाभार्थी जोडा",
  beneficiary_Verified: "लाभार्थी प्रमाणित",
  next_Button: "पुढे",
  pattern_nickname: "कृपया अक्षरे आणि अंक यांचे संयोजन प्रविष्ट करा",
  acc_HolderName: "खातेदाराचे नाव",
  acc_HolderNameReq: "खातेदाराचे नाव आवश्यक आहे",
  mobile_Valid: "कृपया वैध मोबाइल क्रमांक प्रविष्ट करा",

  // other
  heading_otherbank: "इतर बँक लाभार्थी यादी",
  heading_withinBank: "आतील बँक लाभार्थी यादी",

  // Other Bank Corporate
  headingOtherBank: "इतर बँकेचा लाभार्थी जोडा",

  // Within Bank
  headingWithinBank: "आतील बँकेचा लाभार्थी जोडा",
  Cor_accountholdname: "CBS मध्ये खातेदाराचे नाव",
  Validate: "प्रमाणित करा",

  // Transfer History
  transferHistoryHeading: "फंड ट्रान्सफर इतिहास",
  transferReport: "व्यवहार अहवाल",
  column_ViewReceipt: "पावती पहा",
  column_TransTransactionDate: "व्यवहार दिनांक",
  column_TransactionTyep: "व्यवहार प्रकार",
  column_RemitterAcNo: "पाठवणाऱ्याचे खाते क्रमांक",
  column_BeneficiaryAcNo: "लाभार्थ्याचे खाते क्रमांक",
  column_BeneficiaryIFSC: "लाभार्थ्याचा IFSC",
  column_BeneName: "लाभार्थ्याचे नाव",
  column_BeneAmount: "व्यवहाराची रक्कम",
  column_BeneRRN: "RRN",
  column_ResponseCode: "प्रतिक्रिया कोड",

  // Fund Transfer
  column_pay: "पैसे पाठवा",
  column_nickname: "टोपणनाव",
  column_name: "नाव",
  column_accountno: "खाते क्रमांक",
  column_ifsc: "IFSC",
  column_status: "स्थिती",
  remitterDetails: "पाठवणाऱ्याचे तपशील",
  availableBalance: "उपलब्ध शिल्लक:",
  beneficiaryDetails: "लाभार्थीचे तपशील",
  beneficiaryAccountNumber: "लाभार्थ्याचा खाते क्रमांक",
  beneficiaryAccountNumber_required: "लाभार्थ्याचा खाते क्रमांक आवश्यक आहे",
  beneficiaryIFSC: "लाभार्थ्याचा IFSC",
  beneficiaryIFSC_required: "लाभार्थ्याचा IFSC आवश्यक आहे",
  beneficiaryName: "लाभार्थ्याचे नाव",
  beneficiaryName_required: "लाभार्थ्याचे नाव आवश्यक आहे",
  transferDetails: "फंड ट्रान्सफर तपशील",
  amount: "रक्कम",
  amount_required: "रक्कम आवश्यक आहे",
  amount_validation: "कृपया वैध रक्कम प्रविष्ट करा",
  tpin: "TPIN",
  tpin_required: "TPIN आवश्यक आहे",
  tpin_info: "TPIN फक्त अंक असावा आणि किमान 4 अंकांचा असावा",
  remark: "शेरा",
  remark_required: "शेरा आवश्यक आहे",
  continue_Button: "सुरू ठेवा",

  // NEFT
  neft_mainHeading: "नॅशनल इलेक्ट्रॉनिक फंड्स ट्रान्सफर (NEFT)",
  neft_tableHeading: "व्यवहारासाठी लाभार्थी निवडा",

  // RTGS
  rtgs_heading: "रिअल टाइम ग्रॉस सेटलमेंट (RTGS)",
  rtgs_tableHeading: "व्यवहारासाठी लाभार्थी निवडा",
  validIFSC: "कृपया वैध IFSC कोड प्रविष्ट करा",
  validAmount: "कृपया वैध रक्कम प्रविष्ट करा",

  // Within Bank
  withinbank_Heading: "आतील बँक फंड ट्रान्सफर",
  table_heading: "लाभार्थी यादी",

  // Self Account
  main_heading: "स्वतःचे खाते",

  // Personal Loans
  Per_loanMainHeading: "कर्ज तपशील",
  per_loanSubHeading: "कर्ज खाते सारांश",
  per_loanColView: "पहा",
  viewLoanDetails: "कर्ज तपशील पहा",
  per_loanColDisbursement: "वाटप",
  disbursementDetails: "वाटप तपशील",
  per_loanColRepayment: "परतफेड",
  repaymentDetails: "परतफेड तपशील",
  per_colLoanAccNo: "कर्ज खाते क्रमांक",
  per_colLoanAmount: "कर्ज रक्कम",
  per_colLoanBalance: "शिल्लक",
  per_colLoanEMI: "EMI",
  per_colLoanIntRate: "व्याज दर (%)",
  loans_AccountStatement: "खाते स्टेटमेंट",
  loans_paymentHeading: "कर्ज भरणा",
  loans_payNowButton: "आता भरा",
  loans_loanAccountNumber: "कर्ज खाते क्रमांक",
  loans_loanAccountNumberRequired: "कर्ज खाते क्रमांक आवश्यक आहे",
  loansPayment_Amount: "रक्कम",
  loansPayment_AmountRequired: "रक्कम आवश्यक आहे",
  loansPaymentTpin: "TPIN",
  loansPaymentTPINPattern: "TPIN मध्ये फक्त अंक असावेत आणि किमान 4 अंक असावेत",
  loansPaymentTpinRequired: "TPIN आवश्यक आहे",
  loansPayment_Remark: "शेरा",
  loansPayment_Remark: "शेरा आवश्यक आहे",
  loansPayment_Apply: "अर्ज करा",
  customerNoLoans: "ग्राहक नाव/क्रमांक",
  customerNoLoansRequired: "ग्राहक नाव/क्रमांक आवश्यक आहे",
  customerNoLoansPlaceholder: "ग्राहक क्रमांक निवडा",

  loandisbursementDetails: "कर्ज खात्याचे तपशील",
  loanCustomerName: "ग्राहकाचे नाव",
  sanctionAmount: "मंजूर रक्कम",
  SanctionDate: "मंजुरी तारीख",
  TotalDisbursedAmount: "एकूण वितरित रक्कम",
  DisbursedStatus: "वाटप स्थिती",
  Disbursementdate: "वाटप तारीख",
  InterestRateloancol: "व्याज दर",
  DisbursementAmount: "वाटप रक्कम",
  DisbursementDetail: "वाटप तपशील",
  LoanBranchCode: "कर्ज शाखा कोड",
  InterestRatepa: "व्याज दर (% वार्षिक)",
  LoanHolderName: "कर्जधारकाचे नाव",
  LoanAccountType: "खात्याचा प्रकार",
  LoanAccountStatus: "खात्याची स्थिती",
  DisbursalStatus: "वाटप स्थिती",
  InstallmentStart: "हप्ता सुरुवात",
  OutstandingAmount: "थकबाकी रक्कम",
  CurrentMonthEMI: "चालू महिन्याचा EMI",
  InterestAppliedUptoDate: "या तारखेपर्यंत व्याज आकारले आहे",
  UnutilizedLimit: "अवापरलेली मर्यादा",
  ExpiryDate: "कालबाह्यता तारीख",

  // Repayment Details
  EffectiveDate: "अमलात येण्याची तारीख",
  InstallmentAmount: "हप्त्याची रक्कम",
  PrincipalAmount: "मूळ रक्कम",
  InterestRecovered: "वसूल केलेले व्याज",
  OSBalance: "थकबाकी शिल्लक",
  RepaymentDetail: "परतफेड तपशील",

  // Deposit Personal
  deposit_AccountNo: "खाते क्रमांक",
  deposit_ineterestRate: "व्याज दर",
  ineterst_Month: "महिना",
  interest_Days: "दिवस",
  interestDeposit_Rate: "व्याज दर(%)",
  interestDeposit_Date: "व्याज तारीख",
  interestDepositType: "ठेव प्रकार",

  // Deposit
  depositheading: "ठेव खात्याचा तपशील",
  costumerNo: "ग्राहक क्रमांक",
  costumerNoRequired: "ग्राहक क्रमांक आवश्यक आहे",
  costumerNoPlaceholder: "ग्राहक क्रमांक निवडा",
  NodataAvailable: "डेटा उपलब्ध नाही",
  receiptNo: "पावती क्रमांक",
  dateOfReceipt: "पावतीची तारीख",
  principalAmount: "मूळ/हप्ता रक्कम",
  Balance_Deposit: "शिल्लक",
  InterestRate: "व्याज दर (%)",
  maturityAmount: "परिपक्वतेची रक्कम",
  maturityDate: "परिपक्वता तारीख",
  LienAmount: "लियन रक्कम",
  asOfDate: "या तारखेपर्यंत",
  openDeposit_Heading: "नवीन ठेव उघडा",

  // Statement
  statement_heading: "स्टेटमेंट",
  date_message: "कृपया 31 दिवसांच्या आत असलेली तारीख निवडा",
  view_Button: "पहा",
  openingBalance: "प्रारंभिक शिल्लक:",
  dateColumn: "तारीख",
  particularColumn: "तपशील",
  instrumentsColumn: "हस्तांतरण साधने",
  drAmountColumn: "डेबिट रक्कम",
  crAmountColumn: "क्रेडिट रक्कम",
  totalAmount: "एकूण रक्कम",

  // Cheque Request
  cheque_Heading: "चेकबुक विनंती",
  cheque_Delivery: "डिलिव्हरी दिवस",
  cheque_noOfPassbook: "चेकबुकची संख्या",
   cheque_noOfPassbookNotZero:"पासबुकची संख्या शून्य असू शकत नाही",
  cheque_maxAllowedValueIs3:"कमाल 3 चेक बुक परवानगी आहे.",
  cheque_noOfPassbookRequired: "चेकबुकची संख्या आवश्यक आहे",
  cheque_deliveryRequired: "डिलिव्हरी दिवस आवश्यक आहे",
  cheque_Confirmation: "आपणास खात्री आहे की आपण चेकबुक विनंती सुरू करू इच्छिता?",

  // Cheque Status
  cheque_StatusHeading: "चेकबुक स्थिती",
  cheque_no: "चेक क्रमांक",
  cheque_noRequired: "चेक क्रमांक आवश्यक आहे",

  // Profile
  profile_Title: "प्रोफाइल सेटिंग्ज",
  button_updateTPIN: "TPIN अद्यतनित करा",
  button_updatePssword: "पासवर्ड अद्यतनित करा",
  button_forgotTPIN: "TPIN विसरलात?",
  profile_PersonalDetails: "वैयक्तिक माहिती",
  personalDetails_userName: "वापरकर्त्याचे नाव",
  personalDetails_homeBranch: "मुख्य शाखा",
  personalDetails_Address: "पत्ता",
  personalDetails_homeAddressBranch: "मुख्य शाखेचा पत्ता",
  profile_ContactDetails: "संपर्क माहिती",
  contactNo: "संपर्क क्रमांक",
  email_Address: "ईमेल पत्ता",
  communication_Address: "संचार पत्ता",
  profile_Documents: "कागदपत्रे",
  panCardNo: "पॅन कार्ड क्रमांक",
  AadharCard: "आधार क्रमांक",
  companyName: "कंपनीचे नाव",

  // Update TPIN
  updateTpin: "TPIN अद्यतनित करा",
  oldTpin: "जुना TPIN",
  oldTpinPlaceholder: "कृपया जुना TPIN प्रविष्ट करा",
  tpin_required: "TPIN आवश्यक आहे",
  tpinPattern: "कृपया वैध TPIN प्रविष्ट करा",
  newTpin: "नवीन TPIN",
  newTpinPlaceholder: "कृपया नवीन TPIN प्रविष्ट करा",
  confirmTpin: "TPIN पुष्टी करा",
  confirmTpinPlaceholder: "कृपया TPIN पुष्टी करा",
  tpinSubmit: "सबमिट करा",

  // Update Password Modal
  updatePassword: "पासवर्ड अद्यतनित करा",
  passwordRequired: "पासवर्ड आवश्यक आहे",
  oldPassword: "जुना पासवर्ड",
  oldPasswordPlaceholder: "कृपया जुना पासवर्ड प्रविष्ट करा",
  newPassword: "नवीन पासवर्ड",
  newPasswordPlaceholder: "कृपया नवीन पासवर्ड प्रविष्ट करा",
  confirmPassword: "पासवर्ड पुष्टी करा",
  confirmPasswordPlaceholder: "कृपया पासवर्ड पुष्टी करा",
  update_SubmitButton: "सबमिट करा",

  // Forget TPIN Modal
  forgotTpinHeading: "TPIN विसरलात",
  TpinOTP: "OTP प्रविष्ट करा",

  // Complaint Support
  complaint_Heading: "ग्राहक तक्रार स्थिती ब्राउझ करा",
  raiseComplaint_Button: "तक्रार नोंदवा",
  complaintViewColumn: "पहा",
  complaintComaplinId: "तक्रार ID",
  complaintustomerNo: "ग्राहक क्रमांक",
  complaintMobileNo: "मोबाईल क्रमांक",
  comaplaintEmail: "ग्राहक ईमेल",
  complaintName: "नाव",
  complaintCategory: "श्रेणी",
  complaintSubject: "विषय",
  complaintMessage: "संदेश",
  complaintCreatedDate: "तयार केलेली तारीख",
  complaintStatus: "स्थिती",
  complaintResponsemsg: "प्रतिसाद संदेश",
  complaintReplyBy: "उत्तर दिले",
  complaintReplyDt: "उत्तर तारीख",
  categoryRequired: "श्रेणी आवश्यक आहे",
  subjectRequired: "विषय आवश्यक आहे",
  messageRequired: "संदेश आवश्यक आहे",
  complaintResetButton: "रीसेट",
  complaintSubmitButton: "सबमिट",
  supportTeamHeading: "इंटरनेट बँकिंग सपोर्ट टीम",
  Helpdesk: "हेल्पडेस्क",
  officeHours: "कार्यालयीन वेळा",
  bankTiming: "बँक दर रविवारी व प्रत्येक दुसऱ्या आणि चौथ्या शनिवारी बंद असते",
  compaintAddress: "पत्ता",
  complaintEmail: "ईमेल",

  // CORPORATE HOME
  Cor_AccountDetails: "खाते तपशील",
  cor_AccountStatementHeading: "खाते स्टेटमेंट",

  // Financial Overview
  financial_mainHeading: "बँक खाते",
  finCol_AccHolderName: "खातेदाराचे नाव",
  finCol_AccNo: "खाते क्रमांक",
  finCol_AccType: "खात्याचा प्रकार",
  finCol_Balance: "शिल्लक",
  finCol_Details: "तपशील",
  finNoDataAvailable: "डेटा उपलब्ध नाही",

  // Browse Beneficiary
  CorBrowseBeneficiary: "लाभार्थी यादी",
  CorBeneficiaryType: "लाभार्थी प्रकार",
  CorBeneficiaryTypeRequired: "लाभार्थी प्रकार आवश्यक आहे",
  CorAccHolderName: "खातेदाराचे नाव",
  CorSubmitBene: "सबमिट करा",
  BrowseColNickname: "टोपणनाव",
  BrowseColName: "नाव",
  BrowseColAccountNumber: "खाते क्रमांक",
  BrowseColIFSC: "IFSC",
  BrowseColDelete: "हटवा",

  // Payments
  selfAccountTransfer: "स्वतःच्या खात्यात ट्रान्सफर",
  fundTransferHeading: "फंड ट्रान्सफर",
  col_srNo: "अनुक्रमांक",
  col_TransDate: "व्यवहार दिनांक",
  col_rrnNo: "RRN क्रमांक",
  col_tType: "व्यवहार प्रकार",
  col_cbsreceivedDate: "CBS प्राप्त तारीख",
  col_cbsSendDate: "CBS पाठवण्याची तारीख",
  col_cbsrrnNo: "CBS RRN",
  col_narration: "वर्णन",
  col_amountPayment: "रक्कम",
  col_RemAccountNo: "पाठवणाऱ्याचे खाते क्रमांक",
  col_BeneficiaryAccNo: "लाभार्थीचे खाते क्रमांक",
  col_BeneficiaryIFSC: "लाभार्थी IFSC",
  col_BeneficiaryName: "लाभार्थीचे नाव",
  col_Remittercode: "पाठवणारा कोड",
  col_RemitterMobileNo: "पाठवणारा मोबाईल क्र.",
  col_Status: "स्थिती",
  transferType: "ट्रान्सफर प्रकार",
  transferTypeReq: "ट्रान्सफर प्रकार आवश्यक आहे",
  fromAccNo: "ज्या खात्यातून पैसे पाठवायचे",
  BeneNickname: "लाभार्थी टोपणनाव",
  BeneAccountNo: "लाभार्थी खाते क्रमांक",
  BeneAccountNoPlaceholder: "लाभार्थीचे खाते क्रमांक निवडा",
  BeneAccountNoReq: "लाभार्थी खाते क्रमांक आवश्यक आहे",
  BeneIFSCCode: "लाभार्थी IFSC कोड",
  BeneIFSCCodeReq: "लाभार्थी IFSC कोड आवश्यक आहे",
  BeneficiaryNameReq: "लाभार्थीचे नाव आवश्यक आहे",
  BeneNicknamePattern: "लाभार्थी टोपणनाव 10 अक्षरांपेक्षा जास्त नसावे",
  BeneNicknameReq: "लाभार्थी टोपणनाव आवश्यक आहे",
  selectBeneNickname: "लाभार्थी टोपणनाव निवडा",
  transferMethod: "ट्रान्सफर पद्धत",
  fundTransferTableHeading: "मंजुरीसाठी प्रतीक्षेत असलेले व्यवहार",

  bulkPaymentUploadHeading: "बल्क पेमेंट अपलोड",
  recentBulkUploadTransaction: "अलीकडील बल्क अपलोड व्यवहार",
  col_preview: "पूर्वदृश्य",
  col_fileName: "फाईलचे नाव",
  col_totalAmount: "एकूण रक्कम",
  col_transferMethod: "ट्रान्सफर पद्धत",
  col_bulkfromaccount: "ज्या खात्यातून पैसे पाठवायचे",
  colCreatedBy: "कोणाकडून तयार केले",
  colCreatedDate: "तयार केलेली तारीख",
  col_bulkStatuys: "स्थिती",
  sampleFileCSV: "नमुना CSV फाईल",
  sampleFileText: "नमुना मजकूर फाईल",
  resetButton: "रीसेट करा",
  submitBulkButton: "सबमिट करा",
  attachFileUpload: "फाईल जोडा / अपलोड करा",

  //Checker Recent Transaction
  colRT_View: "पहा",
  colRT_TDate: "व्यवहार दिनांक",
  colRT_TType: "व्यवहार प्रकार",
  colRT_Amount: "रक्कम",
  colRT_RRNNo: "RRN क्रमांक",
  colRT_RemAccNo: "पाठवणाऱ्याचे खाते क्रमांक",
  colRT_BenName: "लाभार्थीचे नाव",
  colRT_BenAccNo: "लाभार्थी खाते क्रमांक",
  colRT_BenIfsc: "लाभार्थी IFSC",
  colRT_CBSrecDate: "CBS प्राप्त तारीख",
  colRT_CBSsendDt: "CBS पाठवण्याची तारीख",
  colRT_CBSRRN: "CBS RRN",
  colRT_RemCode: "पाठवणारा कोड",
  colRT_RemMobNo: "पाठवणारा मोबाईल क्र.",
  colRT_Status: "स्थिती",
  colRT_Narration: "वर्णन",
  colRT_Renarks: "शेरा",
  colRT_UploadedBy: "अपलोड केले",
  colRT_UploadedDate: "अपलोड केलेली तारीख",
  colRT_CheckedBy: "तपासले",
  colRT_CheckedDate: "तपासण्याची तारीख",
  colRT_AuthBy: "प्रमाणीकृत केले",
  colRT_AuthDate: "प्रमाणीकृत तारीख",
  colRT_RejectedBy: "नकार दिले",
  colRT_RejectedDate: "नकाराची तारीख",
  applyButtonChecker: "लागू करा",

  //Beneficiary Authorize
  beneficiary_List: "लाभार्थी यादी",
  colBenAuthorizeNickname: "टोपणनाव",
  colBenAuthorizeName: "नाव",
  colBenAuthorizeAccNum: "खाते क्रमांक",
  colBenAuthorizeIFSC: "IFSC",
  colBenAuthorizeDelete: "हटवा",
  AuthDenyButton: "प्रमाणीकृत करा / नकार द्या",
  AuthDenyConfirmationMessage: "आपण लाभार्थी प्रमाणीकृत/नकार देऊ इच्छिता याची खात्री आहे का?",

  //Checker Transaction Report
  CHTranxReportHeading: "व्यवहार अहवाल",
  CHTranxReportFromDate: "तारखेपासून",
  CHTranxReportToDate: "तारखेपर्यंत",
  CHTranxReportTType: "व्यवहार प्रकार",
  CHTranxReportTTypeReq: "व्यवहार प्रकार आवश्यक आहे",
  CHTranxReportStatus: "स्थिती",
  CHTranxReportStatusPlaceholder: "स्थिती निवडा",

  //Bulk Payment Preview
  BulkPaymentPreviewHeading: "बल्क पेमेंट पूर्वदृश्य",
  RecentBulkUploadTransaction: "अलीकडील बल्क अपलोड व्यवहार",

  //Transaction Approve
  TransactionApproveHeading: "व्यवहार मंजूर करा",
  SortPage: "पृष्ठ क्रमवारी",
  NoOfRecords: "नोंदींची संख्या",
  APPROVEDENYButton: "मंजूर करा / नकार द्या",
  AUTHORIZEDENYButton: "प्रमाणीकृत करा / नकार द्या",

  //Transaction Authorize
  TransactionAuthorizeHeading: "व्यवहार प्रमाणीकृत करा",

  //corporate users
  colViewUser: "पहा",
  colActiveInactiveUser: "सक्रिय / निष्क्रिय",
  colNameOfUser: "वापरकर्त्याचे नाव",
  colUserID: "वापरकर्ता ID",
  colUserRole: "वापरकर्ता भूमिका",
  colCorporateId: "कॉर्पोरेट ID",
  colCorporateName: "कॉर्पोरेट नाव",
  colEmailId: "ईमेल ID",
  colAddressUser: "पत्ता",
  colMobileNoUser: "मोबाईल क्रमांक",
  colStatusUser: "स्थिती",
  colAuthStatusUser: "प्रमाणीकृत स्थिती",
  colCreatedDateUser: "तयार केलेली तारीख",

  // Loan Payment
  customerNoLoan: "ग्राहक क्रमांक",
  customerNoLoanReq: "ग्राहक क्रमांक आवश्यक आहे",
  loans_loanAccountNumber: "कर्ज खाते क्रमांक",
  loans_loanAccountNumberRequired: "कर्ज खाते क्रमांक आवश्यक आहे",
  loan_LoanAccountType: "कर्ज खात्याचा प्रकार",
  loan_LoanAccountTypeReq: "कर्ज खात्याचा प्रकार आवश्यक आहे",
  loan_LoanAccountHolderName: "कर्ज खातेदाराचे नाव",
  loan_LoanAccountHolderNameReq: "कर्ज खातेदाराचे नाव आवश्यक आहे",
  LoanEMIAmount: "EMI रक्कम",
  LoanEMIAmountReq: "EMI रक्कम आवश्यक आहे",
  loanTransactionAmount: "व्यवहाराची रक्कम",
  loanTransactionAmountReq: "व्यवहाराची रक्कम आवश्यक आहे",
  loanRemark: "शेरा",
  loanRemarkReq: "शेरा आवश्यक आहे",
  loanApplyButton: "लागू करा",

  //Card Details
  card_Hi: "नमस्कार",

  //CORPORATECARDDASHBOARD
  cor_card_hi: "नमस्कार",
  cor_card_Balance: "शिल्लक",

  //OTP
  OTP_heading: "कृपया OTP प्रविष्ट करा",
  OTP_mainHeading: "OTP सत्यापन",
  otp_title: "आपल्या क्रमांकावर पाठवलेला OTP कोड प्रविष्ट करा.",
  otplimits: "आपल्याकडे",
  otplimitstext: "प्रयत्न शिल्लक आहेत",
  otpSubmit: "सबमिट करा",

  //Routes
  routeHome: "मुख्यपृष्ठ",
  routeAccount: "खाते",
  routeSetCustLimit: "खाते मर्यादा सेट करा",
  routeViewStatement: "स्टेटमेंट पाहा",
  routeBeneficiaryMaster: "लाभार्थी मास्टर",
  routeOtherBank: "इतर बँक",
  routeWithinbank: "बँकेमध्ये",
  routeFundTransfer: "फंड ट्रान्सफर",
  routeNEFTFundTransfer: "NEFT",
  routeRTGSFundTransfer: "RTGS",
  routeSelfAccount: "स्वतःचे खाते",
  routePyamentSuccess: "पेमेंट यशस्वी",
  routeNEFTDetails: "NEFT तपशील",
  routeReceipt: "पावती",
  routeRTGSDetails: "RTGS तपशील",
  routeInternalDetails: "आंतरर्गत तपशील",
  routeTransactionReceipt: "व्यवहार पावती",
  routeTransferHistory: "ट्रान्सफर इतिहास",
  routeCards: "कार्ड्स",
  routeLoans: "कर्जे",
  routeloansFields: "कर्ज तपशील",
  routeloansPayment: "कर्ज पेमेंट",
  routeLoansDETAILS: "कर्ज तपशील",
  routeDisbursementDetails: "रक्कम वितरण तपशील",
  routeRepaymentDetails: "परतफेड तपशील",
  routeViewStmt: "स्टेटमेंट पाहा",
  routeDeposit: "ठेव",
  routeDepositAccDetails: "ठेव खात्याचा तपशील",
  routeInterestRate: "व्याजदर",
  routeOpenNewDeposit: "नवीन ठेव उघडा",
  routeStmts: "स्टेटमेंट्स",
  routeCheque: "चेक",
  routeRequest: "विनंती",
  routeStatus: "स्थिती",
  routeStopPayment: "पेमेंट थांबवा",
  routePositivePay: "पॉझिटिव्ह पे",
  routeCertificattes: "प्रमाणपत्रे",
  routeProfile: "प्रोफाइल",
  routeCustSupport: "ग्राहक सहाय्य",
  routeRaiseComplaint: "तक्रार नोंदवा",

  //Corporate Maker
  routeCorHome: "मुख्यपृष्ठ",
  routeCorAccount: "खाते",
  routeCorLimit: "खाते मर्यादा सेट करा",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorLoanDetails: "कर्ज तपशील",
  routeCorBeneficiaryMaster: "लाभार्थी मास्टर",
  routeCorOtherBank: "इतर बँक जोडा",
  routeCorWithBank: "बँकेत जोडा",
  routeBrowse: "ब्राउझ",
  routePayments: "पेमेंट्स",
  routeCorFundTransfer: "फंड ट्रान्सफर",
  routeCorSelfAccount: "स्वतःचे खाते",
  routeCorBulkPyment: "बल्क पेमेंट अपलोड",
  routeCorTranxReport: "व्यवहार अहवाल",
  routeBulkUploadPreview: "बल्क अपलोड पूर्वदृश्य",
  routeFundTransferPreview: "फंड ट्रान्सफर पूर्वदृश्य",
  routeBulkFundTransferpreview: "बल्क फंड ट्रान्सफर पूर्वदृश्य",
  routeCorLoans: "कर्जे",
  routeloansFields: "कर्ज माहिती",
  routeCorloansPayment: "कर्ज पेमेंट",
  routeCorLoansDETAILS: "कर्ज तपशील",
  routeCorDisbursementDetails: "रक्कम वितरण तपशील",
  routeCorRepaymentDetails: "परतफेड तपशील",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorDeposit: "ठेव",
  routeCorDepositAccDetails: "ठेव खात्याचा तपशील",
  routeCorInterestRate: "व्याजदर",
  routeCorOpenNewDeposit: "नवीन ठेव उघडा",
  routeCorStmts: "स्टेटमेंट्स",
  routeCorProfile: "प्रोफाइल",
  routeCorUser: "वापरकर्ते",

  //Corporate Checker
  routeCorChckHome: "मुख्यपृष्ठ",
  routeCorAccount: "खाते",
  routeCorAccLimit: "खाते मर्यादा सेट करा",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorLoanDetails: "कर्ज तपशील",
  routeCorTrxReport: "व्यवहार अहवाल",
  routeCheckPreview: "चेकर पूर्वदृश्य नोंद",
  routeCheckBulkPreview: "बल्क पूर्वदृश्य",
  routeCheckBulkFundTrasfer: "चेकर फंड ट्रान्सफर पूर्वदृश्य",
  routeCheckApprove: "चेकर मंजुरी",
  routeCheckViewRecord: "चेकर नोंद पहा",

  //Corporate Authorize
  routeAuthHome: "मुख्यपृष्ठ",
  routeAuthBulkPrevuew: "बल्क पूर्वदृश्य",
  routeAuthTransactionReport: "व्यवहार अहवाल",
  routeAuthViewRecord: "चेकर नोंद पहा",
  routeAuthBulkPreview: "बल्क पूर्वदृश्य",
  routeAuthPreview: "पूर्वदृश्य",
  routeAuthTranxAuth: "व्यवहार प्रमाणीकृत करा",
  routeAuthApprove: "मंजूर करा",
  routeBenAuthorize: "लाभार्थी प्रमाणीकृत करा",

  //Corporate Maker
  routeCorHome: "मुख्यपृष्ठ",
  routeCorAccount: "खाते",
  routeCorLimit: "खाते मर्यादा सेट करा",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorLoanDetails: "कर्ज तपशील",
  routeCorBeneficiaryMaster: "लाभार्थी मास्टर",
  routeCorOtherBank: "इतर बँक जोडा",
  routeCorWithBank: "बँकेत जोडा",
  routeBrowse: "ब्राउझ",
  routePayments: "पेमेंट्स",
  routeCorFundTransfer: "फंड ट्रान्सफर",
  routeCorSelfAccount: "स्वतःचे खाते",
  routeCorBulkPyment: "बल्क पेमेंट अपलोड",
  routeCorTranxReport: "व्यवहार अहवाल",
  routeBulkUploadPreview: "बल्क अपलोड पूर्वदृश्य",
  routeFundTransferPreview: "फंड ट्रान्सफर पूर्वदृश्य",
  routeBulkFundTransferpreview: "बल्क फंड ट्रान्सफर पूर्वदृश्य",
  routeCorLoans: "कर्जे",
  routeloansFields: "कर्ज माहिती",
  routeCorloansPayment: "कर्ज पेमेंट",
  routeCorLoansDETAILS: "कर्ज तपशील",
  routeCorDisbursementDetails: "रक्कम वितरण तपशील",
  routeCorRepaymentDetails: "परतफेड तपशील",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorDeposit: "ठेव",
  routeCorDepositAccDetails: "ठेव खात्याचा तपशील",
  routeCorInterestRate: "व्याजदर",
  routeCorOpenNewDeposit: "नवीन ठेव उघडा",
  routeCorStmts: "स्टेटमेंट्स",
  routeCorProfile: "प्रोफाइल",
  routeCorUser: "वापरकर्ते",

  //Corporate Checker
  routeCorChckHome: "मुख्यपृष्ठ",
  routeCorAccount: "खाते",
  routeCorAccLimit: "खाते मर्यादा सेट करा",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorLoanDetails: "कर्ज तपशील",
  routeCorTrxReport: "व्यवहार अहवाल",
  routeCheckPreview: "चेकर पूर्वदृश्य नोंद",
  routeCheckBulkPreview: "बल्क पूर्वदृश्य",
  routeCheckBulkFundTrasfer: "चेकर फंड ट्रान्सफर पूर्वदृश्य",
  routeCheckApprove: "चेकर मंजुरी",
  routeCheckViewRecord: "चेकर नोंद पहा",

  //Corporate Authorize
  routeAuthHome: "मुख्यपृष्ठ",
  routeAuthBulkPrevuew: "बल्क पूर्वदृश्य",
  routeAuthTransactionReport: "व्यवहार अहवाल",
  routeAuthViewRecord: "चेकर नोंद पहा",
  routeAuthBulkPreview: "बल्क पूर्वदृश्य",
  routeAuthPreview: "पूर्वदृश्य",
  routeAuthTranxAuth: "व्यवहार प्रमाणीकृत करा",
  routeAuthApprove: "मंजूर करा",
  routeBenAuthorize: "लाभार्थी प्रमाणीकृत करा",

  //Corporate Maker
  routeCorHome: "मुख्यपृष्ठ",
  routeCorAccount: "खाते",
  routeCorLimit: "खाते मर्यादा सेट करा",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorLoanDetails: "कर्ज तपशील",
  routeCorBeneficiaryMaster: "लाभार्थी मास्टर",
  routeCorOtherBank: "इतर बँक जोडा",
  routeCorWithBank: "बँकेत जोडा",
  routeBrowse: "ब्राउझ",
  routePayments: "पेमेंट्स",
  routeCorFundTransfer: "फंड ट्रान्सफर",
  routeCorSelfAccount: "स्वतःचे खाते",
  routeCorBulkPyment: "बल्क पेमेंट अपलोड",
  routeCorTranxReport: "व्यवहार अहवाल",
  routeBulkUploadPreview: "बल्क अपलोड पूर्वदृश्य",
  routeFundTransferPreview: "फंड ट्रान्सफर पूर्वदृश्य",
  routeBulkFundTransferpreview: "बल्क फंड ट्रान्सफर पूर्वदृश्य",
  routeCorLoans: "कर्जे",
  routeloansFields: "कर्ज माहिती",
  routeCorloansPayment: "कर्ज पेमेंट",
  routeCorLoansDETAILS: "कर्ज तपशील",
  routeCorDisbursementDetails: "रक्कम वितरण तपशील",
  routeCorRepaymentDetails: "परतफेड तपशील",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorDeposit: "ठेव",
  routeCorDepositAccDetails: "ठेव खात्याचा तपशील",
  routeCorInterestRate: "व्याजदर",
  routeCorOpenNewDeposit: "नवीन ठेव उघडा",
  routeCorStmts: "स्टेटमेंट्स",
  routeCorProfile: "प्रोफाइल",
  routeCorUser: "वापरकर्ते",

  //Corporate Checker
  routeCorChckHome: "मुख्यपृष्ठ",
  routeCorAccount: "खाते",
  routeCorAccLimit: "खाते मर्यादा सेट करा",
  routeCorViewStmt: "स्टेटमेंट पाहा",
  routeCorLoanDetails: "कर्ज तपशील",
  routeCorTrxReport: "व्यवहार अहवाल",
  routeCheckPreview: "चेकर पूर्वदृश्य नोंद",
  routeCheckBulkPreview: "बल्क पूर्वदृश्य",
  routeCheckBulkFundTrasfer: "चेकर फंड ट्रान्सफर पूर्वदृश्य",
  routeCheckApprove: "चेकर मंजुरी",
  routeCheckViewRecord: "चेकर नोंद पहा",

  //Corporate Authorize
  routeAuthHome: "मुख्यपृष्ठ",
  routeAuthBulkPrevuew: "बल्क पूर्वदृश्य",
  routeAuthTransactionReport: "व्यवहार अहवाल",
  routeAuthViewRecord: "चेकर नोंद पहा",
  routeAuthBulkPreview: "बल्क पूर्वदृश्य",
  routeAuthPreview: "पूर्वदृश्य",
  routeAuthTranxAuth: "व्यवहार प्रमाणीकृत करा",
  routeAuthApprove: "मंजूर करा",
  routeBenAuthorize: "लाभार्थी प्रमाणीकृत करा",

  // Marathi translations
dashQuickTransfer: "त्वरित पैसे पाठवा",
dashNotransactionsyet: "अद्याप कोणतेही व्यवहार झालेले नाहीत",
dashNotransactionsyetDesc: "तुमचा पहिला व्यवहार झाल्यानंतर तो इथे दिसेल",
dashAddnew: "नवीन जोडा",
dashAccountstatement: "खाते विवरण",
dashQuickLinks: "द्रुत दुवे",
dashAccountdetails: "खात्याचे तपशील",
dashAccountstatements: "खाते विवरण",
dashFundtransfer: "रक्कम ट्रान्सफर",
dashGenerateQRCode: "QR कोड तयार करा",
dashRecentTransactions: "अलीकडील व्यवहार",
dashSeeall: "सर्व पहा",
dashCreateTransactions: "व्यवहार तयार करा"

};
